/**
 * @module Section-Shared-Blogs
 */

import { NavLink } from "react-router-dom";
import { TypeSectionBlog } from "../../../@types/sectionTypes";
import SectionBlogsCommonBox from "../../blogs/blog-box";

/**
 * 
 * @param props : Data supplied to display blog list
 * @returns Markup for recent blogs
 */
const SectionSharedBlogs = (
    props: {
        _blogs: TypeSectionBlog
    }
) => {
    const { _blogs } = props;
    return (
        <div className="section-full p-t120 p-b90 site-bg-gray av-blog-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12 m-b40">
                        {/* TITLE START*/}
                        <div className="section-head left">
                            <h2 className="av-large-title">{_blogs.title}</h2>
                            <p>{_blogs.subtitle}</p>
                        </div>
                        {/* TITLE END*/}
                    </div>
                    <div className="col-lg-6 col-md-12 m-b40 text-right">
                        <NavLink 
                            to="/blogs" 
                            className="site-button"
                            style={{
                                background: '#4557F6',
                                color: '#fff',
                                padding: '12px 24px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '600',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.3s ease',
                                marginTop: '20px'
                            }}
                        >
                            See All Insights
                            <i className="feather feather-arrow-right" />
                        </NavLink>
                    </div>
                </div>
                <div className="section-content">
                    <div className="owl-carousel av-blog-carousel next-prev-top-right m-b30">
                        {
                            _blogs.blogs.map((_item, _index) => {
                                return (
                                    <div key={_index} className="item">
                                        <SectionBlogsCommonBox _data={_item} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SectionSharedBlogs;